// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '5c5fe6f4c19b2ae1b0d9be18bf01bea8b3bba04b',
  short: '5c5fe6f',
  builtAt: '2026-10-05T05:42:29.332Z',
} as const;
